import type { CuratedStory } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface SingleStoryCitylabVerticalIntegrityProps {
    items?: CuratedStory[];
}

export default function integrityCheck({
    items = [],
}: SingleStoryCitylabVerticalIntegrityProps): IntegrityStatus {
    const messages = checkItemArrayIntegrity(items);

    if (items.length) {
        const [content] = items;

        const { eyebrow, byline, image } = content;

        if (!image?.baseUrl) messages.push("Missing image baseUrl");

        if (!byline) messages.push("Missing byline");

        if (!eyebrow) messages.push("Missing eyebrow");
    }

    return messages;
}
